module.exports = __webpack_public_path__ + "static/media/mit-logo.0057489d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/about-us/mit-logo.png
// module id = 1179
// module chunks = 0